<template>
    <vx-table-row>
        <vx-table-row-title>
            <span data-test="phone-number">{{ formatPhoneNumber(props.modelValue.phone_number) }}</span>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Vendor: </template>
            <span data-test="vendor">{{ vendorLabels[props.modelValue.vendor] }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="campaign">
            <template v-slot:label> Campaign: </template>
            <vx-badge
                v-if="props.modelValue.campaign_id"
                color="slate"
                size="xs"
                class="font-mono"
                data-test="campaign-id"
            >
                {{ props.modelValue.campaign_id }}
            </vx-badge>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Class: </template>
            <vx-popover
                v-if="props.modelValue.att_message_class"
                hover
                :arrow="true"
                placement="top"
                data-test="message-class"
            >
                {{ messageClassLabel(props.modelValue.att_message_class) }}
                <template v-slot:content>
                    <div class="text-xs max-w-[240px]">
                        {{ messageClassDetail(props.modelValue.att_message_class) }}
                    </div>
                </template>
            </vx-popover>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="brand">
            <template v-slot:label> Brand: </template>
            <kiosk-tcr-brand-cell
                v-if="props.modelValue.brand_id"
                :brandId="props.modelValue.brand_id"
                :displayName="props.modelValue.brand_display_name"
                :verified="props.modelValue.brand_verified"
                :vettingScore="props.modelValue.brand_vetting_score"
                :entityType="props.modelValue.brand_entity_type"
                :vettingClass="props.modelValue.brand_vetting_class"
                :vettingStatus="props.modelValue.brand_vetting_status"
            ></kiosk-tcr-brand-cell>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="team">
            <template v-slot:label> Team: </template>
            <kiosk-team-cell
                v-if="props.modelValue.team_id !== null"
                :team-id="props.modelValue.team_id"
                :team-name="props.modelValue.team_name ?? ''"
                :team-status="props.modelValue.team_status ?? ''"
                :team-status-reason="props.modelValue.team_status_reason"
            />
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <vx-popover hover :arrow="true" placement="top" :key="syncedAtKey">
                {{ fromNow(props.modelValue.synced_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.synced_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { formatPhoneNumber } from '~/components/filters';
import KioskTeamCell from '~/components/kiosk/KioskTeamCell.vue';
import KioskTcrBrandCell from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrBrandCell.vue';
import { messageClassDetail, messageClassLabel, vendorLabels } from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrPhoneNumber } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrPhoneNumber;
}>();

const syncedAtKey = useInterval(60000);
</script>
